import { BASE_RATES, LEADER_RATES } from '@/utils/const'
import { InputFormValues } from './types'

/**
 * 指定された入力に基づいて1年目から10年目までの給与を計算し、
 * 各年の給与を配列形式で返す関数
 *
 * @param {InputFormValues} data - 入力フォームの値
 * @param {'monthlyIncome' | 'annualIncome'} data.calculationType - 計算タイプ（月収または年収）
 * @param {'inPlanning' | 'notParticipating'} data.leaderProject - リーダー案件の参加状況
 * @param {number} data.clientBillingRate - 顧客請求単価（55から200の範囲）
 * @returns {number[]} 各年の給与を含む配列
 *
 * @example
 * const input = {
 *   calculationType: 'monthlyIncome',
 *   leaderProject: 'inPlanning',
 *   clientBillingRate: 90
 * }
 * const result = payroll(input)
 * console.log(result)
 * // [468000, 504000, 522000, 576000, 612000, 648000, 684000, 720000, 756000, 792000]
 */
export const payroll = (data: InputFormValues): number[] => {
  const { calculationType, leaderProject, clientBillingRate } = data

  // clientBillingRateを550,000から2,000,000の範囲に変換
  const adjustedClientBillingRate = clientBillingRate * 10000

  // 還元率の調整
  const adjustedRates: number[] = BASE_RATES.map((rate) => {
    if (leaderProject === 'notParticipating') return rate

    const leaderRate: number = getLeaderRate(adjustedClientBillingRate)
    return rate + leaderRate
  })

  // 各年の給与を計算
  const salaries: number[] = adjustedRates.map((rate) => {
    return adjustedClientBillingRate * rate
  })

  // 月収・年収の計算
  const finalSalaries: number[] =
    calculationType === 'monthlyIncome'
      ? salaries
      : salaries.map((salary) => salary * 12)

  // 小数点を切り捨てて結果を配列形式で返す
  return finalSalaries.map((salary) => Math.floor(salary))
}

/**
 * クライアント請求単価に基づいてリーダー案件の還元率を取得する関数
 *
 * @param {number} clientBillingRate - 顧客請求単価（550,000から2,000,000の範囲）
 * @returns {number} リーダー案件の還元率
 */
export const getLeaderRate = (clientBillingRate: number): number => {
  if (clientBillingRate >= 1000000) return LEADER_RATES[6]
  if (clientBillingRate >= 900000) return LEADER_RATES[5]
  if (clientBillingRate >= 800000) return LEADER_RATES[4]
  if (clientBillingRate >= 700000) return LEADER_RATES[3]
  if (clientBillingRate >= 600000) return LEADER_RATES[2]
  if (clientBillingRate >= 500000) return LEADER_RATES[1]
  return LEADER_RATES[0]
}
